import React, { useState } from "react";
import { motion } from "framer-motion";
import { useI18n } from "../i18n";
import { SecondaryHeader, Footer } from "../components/Frumy";
import { FeedbackForm } from "../components/Feedback";
import { EnvelopeSimple, Bank, ChatCircleDots } from "@phosphor-icons/react";

export default function Contatti() {
  const { t } = useI18n();
  const [showFeedback, setShowFeedback] = useState(false);

  return (
    <div className="min-h-screen flex flex-col">
      <SecondaryHeader />
      <main className="flex-1 max-w-2xl mx-auto px-4 sm:px-6 py-12 w-full" data-testid="contatti-page">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <span className="grid place-items-center h-12 w-12 rounded-xl bg-emerald-50 text-[var(--frumy-green)]">
            <EnvelopeSimple weight="fill" size={26} aria-hidden />
          </span>
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight mt-5 text-[var(--heading)]">{t("contattiTitle")}</h1>
          <p className="text-base leading-relaxed text-[var(--text-muted)] mt-4">{t("contattiIntro")}</p>

          <a data-testid="contatti-email" href="mailto:info@frumy.app"
            className="frumy-card mt-8 flex items-center gap-4 p-5 hover:border-[var(--frumy-green)] transition-colors">
            <span className="grid place-items-center h-11 w-11 rounded-xl brand-gradient text-white shrink-0">
              <EnvelopeSimple weight="fill" size={22} aria-hidden />
            </span>
            <span>
              <span className="block text-xs tracking-[0.12em] uppercase font-bold text-[var(--text-muted)]">{t("contattiEmailLabel")}</span>
              <span className="block font-bold text-lg text-[var(--heading)]">info@frumy.app</span>
            </span>
          </a>

          <div className="frumy-card mt-4 flex items-start gap-4 p-5">
            <span className="grid place-items-center h-11 w-11 rounded-xl bg-[var(--frumy-muted)] text-[var(--frumy-green)] shrink-0">
              <Bank weight="duotone" size={22} aria-hidden />
            </span>
            <p className="text-sm leading-relaxed text-[var(--text-muted)]">{t("contattiUnsupported")}</p>
          </div>

          <button data-testid="contatti-feedback-cta" onClick={() => setShowFeedback((v) => !v)}
            className="pill-btn cta-metal mt-6 inline-flex items-center gap-2 text-white font-bold px-6 py-3">
            <ChatCircleDots weight="fill" size={18} aria-hidden />{t("contattiFeedbackCta")}
          </button>

          {showFeedback && (
            <FeedbackForm type="parsing" onClose={() => setShowFeedback(false)} onSent={() => setShowFeedback(false)} />
          )}
        </motion.div>
      </main>
      <Footer />
    </div>
  );
}
